var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-chat",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-chat1",
    serifid: "iconB-chat"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.684,19c-0.522,0 -0.784,-0.01 -1.034,0.041c-0.176,0.036 -0.347,0.096 -0.508,0.178c-0.227,0.116 -0.424,0.288 -0.832,0.614l-2.386,1.908c-0.703,0.563 -1.126,0.718 -1.422,0.719c-0.457,0 -0.889,-0.207 -1.174,-0.564c-0.185,-0.232 -0.328,-0.659 -0.328,-1.561l0,-12.535c0,-1.925 0.061,-2.881 0.436,-3.616c0.383,-0.753 0.995,-1.365 1.748,-1.748c0.735,-0.375 1.691,-0.436 3.616,-0.436l8.4,0c1.925,0 2.881,0.061 3.616,0.436c0.753,0.383 1.365,0.995 1.748,1.748c0.375,0.735 0.436,1.691 0.436,3.616l0,5.4c0,1.925 -0.061,2.881 -0.436,3.616c-0.383,0.753 -0.995,1.365 -1.748,1.748c-0.735,0.375 -1.691,0.436 -3.616,0.436l-6.516,0Zm-5.684,0.919l2.061,-1.648c0.566,-0.454 0.856,-0.672 1.172,-0.833c0.32,-0.164 0.662,-0.284 1.015,-0.356c0.347,-0.072 0.71,-0.082 1.436,-0.082l6.516,-0c1.436,-0 2.16,0.061 2.708,-0.218c0.376,-0.192 0.682,-0.498 0.874,-0.874c0.279,-0.548 0.218,-1.272 0.218,-2.708l0,-5.4c0,-1.436 0.061,-2.16 -0.218,-2.708c-0.192,-0.376 -0.498,-0.682 -0.874,-0.874c-0.549,-0.279 -1.272,-0.218 -2.708,-0.218l-8.4,-0c-1.436,-0 -2.16,-0.061 -2.708,0.218c-0.376,0.192 -0.682,0.498 -0.874,0.874c-0.279,0.548 -0.218,1.272 -0.218,2.708l0,12.119Zm8.997,-11.418c-0,0.545 -0.442,0.987 -0.987,0.987l-5.053,-0c-0.545,-0 -0.987,-0.442 -0.987,-0.987c-0,-0.544 0.442,-0.987 0.987,-0.987l5.053,-0c0.545,-0 0.987,0.443 0.987,0.987Zm2.992,3.48c-0,0.545 -0.442,0.987 -0.987,0.987l-8.016,-0c-0.545,-0 -0.987,-0.442 -0.987,-0.987c-0,-0.545 0.442,-0.987 0.987,-0.987l8.016,-0c0.545,-0 0.987,0.442 0.987,0.987Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBChat);
export default __webpack_public_path__ + "static/media/iconB-chat.7a37dad099f0ac2a2185853f8e99eae2.svg";
export { ForwardRef as ReactComponent };